import { lazy } from 'react'
import type { LazyExoticComponent } from 'react'
import type { ComponentType } from 'react'

type AppRoute = {
  path: string
  component: LazyExoticComponent<ComponentType>
}

export const dashboardRoute: AppRoute = {
  path: '/dashboard',
  component: lazy(() => import('@/pages/dashboard/ui/DashboardPage')),
}

export const homeRoute: AppRoute = {
  path: '/',
  component: lazy(() => import('@/pages/home/ui/HomePage')),
}

export const loginRoute: AppRoute = {
  path: '/login',
  component: lazy(() => import('@/pages/login/ui/LoginPage')),
}

export const notFoundRoute: AppRoute = {
  path: '*',
  component: lazy(() => import('@/pages/not-found/ui/NotFoundPage')),
}
